import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import SchoolThemesItemForm from "./SchoolThemesItemForm";
import SchoolThemesItemBrowser from "./SchoolThemesItemBrowser";

const SchoolThemesPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="school_theme"
            modeApiName2="school_themes"
            ItemFormComponent={SchoolThemesItemForm}
            browserStyle={{width: "min(35%, 460px)", minWidth: "310px"}}
            ItemBrowserComponent={SchoolThemesItemBrowser}
        />
    );
};

export default SchoolThemesPage;